import { render, staticRenderFns } from "./PagePasswordReset.vue?vue&type=template&id=248e3474&scoped=true&"
import script from "./PagePasswordReset.vue?vue&type=script&lang=js&"
export * from "./PagePasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./PagePasswordReset.vue?vue&type=style&index=0&id=248e3474&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e3474",
  null
  
)

export default component.exports